export interface Props {
    /**
     * @title Texto
     * @format html
     */
    text: string
}

export default function Text({ text }: Props) {
    if (!text) return null

    return (
        <div className='max-w-[1024px] px-3.5 mx-auto my-8'>
            <div
                className='text-sm leading-normal [&_h1]:text-[25px] [&_h1]:text-center [&_h1]:uppercase [&_h1]:font-extrabold [&_h1_strong]:text-red-wine [&_h2]:text-[25px] [&_h2]:text-center [&_h2]:uppercase [&_h2]:font-extrabold [&_h2_strong]:text-red-wine [&_h3]:text-[25px] [&_h3]:text-center [&_h3]:uppercase [&_h3]:font-extrabold [&_h3_strong]:text-red-wine [&_ul]:list-disc [&_ul]:list-inside'
                dangerouslySetInnerHTML={{ __html: text }}
            />
        </div>
    )
}
